import * as yup from "yup";

import { ssn_validator, Strong_Password } from "./ValidationFunctions";

export const validationSchema = yup.object().shape({
  cellphone: yup
    .string()
    .required("شماره موبایل را وارد کنید")
    .matches(
      "^[0][9][0-9]{9}$" || "^[۰][۹][۰-۹]{9}$",
      "شماره اشتباه است (09xxxx)"
    ),
  first_name: yup.string().required("نام را وارد کنید"),
  last_name: yup.string().required("نام خوانوادگی را وارد کنید"),
  ssn: yup.lazy((value) => {
    if (value !== undefined && ssn_validator(value) === false) {
      return yup
        .string()
        .matches("aa", "کد ملی اشتباه است")
        .max(10, "کد ملی اشتباه است");
    }
    return yup.string().required("کد ملی را وارد کنید");
  }),
  email: yup
    .string()
    .email("ایمیل را صحیح وارد کنید")
    .required("ایمیل را وارد کنید"),
  password: yup
    .string()
    .required("پسورد را وارد کنید")
    .matches(
      Strong_Password,
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک،بزرگ،اعداد  و (@،!،%،..)است"
    ),

  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), null], "پسورد اشتباه است")
    .required("پسورد را دوباره تایپ کنید"),
  board_title: yup.string().required("نام دفتر را وارد کنید"),
  phone: yup
    .string()
    .required("شماره دفتر را وارد کنید")
    .matches("^[0][2][1-9]{9}$", "شماره اشتباه است (02xxx)"),
  office_number: yup
    .string()
    .required("شماره دفتر را وارد کنید")
    .matches("^[0][2][1-9]{9}$", "شماره اشتباه است (02xxx)"),
  start_work_time: yup.string(),
  end_work_time: yup.string(),
  country: yup.string(),
  state: yup.string(),
  city: yup.string(),
  district: yup.string(),
  address: yup.string().required("ادرس خود را وارد کنید"),
  addressDetails: yup
    .string()
    .required("ادرس خود را وارد کنید")
    .min(3, "حداقل تعداد کاراکتر 3 عدد"),
  pocode: yup
    .number()
    .min(1111111111, "کد پستی اشتباه است")
    .max(9999999999, "کد پستی اشتباه است")
    .required("کد پستی را وارد کنید"),
});

export const InitialValues = {
  cellphone: "",
  first_name: "",
  last_name: "",
  ssn: "",
  email: "",
  password: "",
  confirm_password: "",
  board_title: "",
  phone: "",
  office_number: "",
  start_work_time: new Date(0, 0, 0, 7),
  end_work_time: new Date(0, 0, 0, 22),
  country: "",
  province: "",
  city: "",
  district: "",
  address: "",
  addressDetails: "",
  pocode: "",
};
